import { getLegalDocPrefillLabel } from '@common/utils/legalDocPrefills';
import type { MatterFieldWidget } from '@common/utils/matterFields';
import MatterFieldInput from '../MatterFieldInput';
import PrefillField from './PrefillField';

interface Props {
    tag: string;
    widget: MatterFieldWidget;
    value: string;
    error?: string;
    onChange(value: string): void;
}

export default function ExtraPrefillField({ tag, widget, value, error, onChange }: Props) {
    return (
        <PrefillField
            label={getLegalDocPrefillLabel(tag)}
            error={error}
            maxWidth={widget === 'address' ? '480px' : '320px'}
        >
            <MatterFieldInput
                name={tag}
                widget={widget}
                value={value}
                error={Boolean(error)}
                onChange={onChange}
            />
        </PrefillField>
    );
}
